module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-board-3.315ea352.webp";